import { ActionReducer, createReducer, on } from '@ngrx/store';

import {
  addReportTemplateItem,
  deleteReportTemplateItem,
  deleteTracksFromReportsPage,
  loadReportTemplatesList,
  loadReportTemplatesListFailure,
  loadReportTemplatesListSuccess,
  setLastPageStateReports,
  setParamsCreateTrackForReports,
  updateReportTemplateItem,
} from '@store/reports/reports.actions';
import {
  initialStateReports,
  ReportsState,
  reportTemplateAdapter,
} from '@store/reports/reports.state';

export const reportsReducer: ActionReducer<ReportsState> = createReducer(
  initialStateReports,
  on(loadReportTemplatesList, (state) => ({
    ...state,
    loading: true,
    error: undefined,
  })),

  on(loadReportTemplatesListSuccess, (state, { list }) =>
    reportTemplateAdapter.setAll(list, {
      ...state,
      loading: false,
    }),
  ),

  on(loadReportTemplatesListFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(addReportTemplateItem, (state, { item }) => reportTemplateAdapter.addOne(item, state)),
  on(updateReportTemplateItem, (state, { id, changes }) =>
    reportTemplateAdapter.updateOne({ id: +id, changes }, state),
  ),
  on(deleteReportTemplateItem, (state, { id }) => reportTemplateAdapter.removeOne(+id, state)),

  on(setLastPageStateReports, (state, { newPageState }) => {
    return {
      ...state,
      lastPageState: {
        ...state.lastPageState,
        ...newPageState,
      },
    };
  }),
  on(setParamsCreateTrackForReports, (state, { params, cacheKey }) => {
    return {
      ...state,
      lastPageState: {
        ...state.lastPageState,
        paramsCreateTrack: { [cacheKey]: params },
      },
    };
  }),
  on(deleteTracksFromReportsPage, (state) => {
    return {
      ...state,
      lastPageState: {
        ...state.lastPageState,
        paramsCreateTrack: {},
      },
    };
  }),
);
